import { IOrganisationType, queryKeys } from '../../shared';
import { useDelete, useSave } from '../../shared/hooks/new-base.hook';
import { useItem, UseItemParams, useList, UseListParams } from '../../shared/hooks/new-read-only.hook';
import { organisationTypeClient } from '../clients/organisation-type.client';

const client = organisationTypeClient;
const listKey = queryKeys.ORGANISATION_TYPES;
const itemKey = queryKeys.ORGANISATION_TYPE;

export function useOrganisationTypeList(...args: UseListParams<IOrganisationType>) {
    return useList(client, listKey, args);
}

export function useOrganisationType(...args: UseItemParams<IOrganisationType>) {
    return useItem(client, itemKey, args);
}

export function useSaveOrganisationType() {
    return useSave(client, listKey, itemKey);
}

export function useDeleteOrganisationType() {
    return useDelete(client, listKey);
}
